import React from 'react';
import { Grid } from '@mui/material';
import FinderSelect from '../../atoms/FinderSelect/FinderSelect';
import './RunFilters.scss';
import { DEFAULT_RUN_OPTION, FinderSelectOptionType } from '../../pages/Nba/RunsFinder/constants';
import { useFilterContext, useFilterDispatchContext } from '../../contexts/FilterContext';

interface IProps {
  runOptions: FinderSelectOptionType[];
};

function RunFilters({ runOptions }: IProps) {
  const filterContext: any = useFilterContext();
  const filterDispatchContext: any = useFilterDispatchContext();

  const handleRunOptions = (selection: string) => {
    filterDispatchContext({
      type: 'runOptionsSelected',
      runOption: selection,
    });
  };

  return (
    <Grid item xs={4}>
      <FinderSelect
        label='Run Options'
        value={filterContext.runOption || DEFAULT_RUN_OPTION}
        options= {runOptions}
        handleSelection={handleRunOptions}
        selectStyleOverrides={{
          select: { 'minHeight': '56px' },
          formControl: { width: '100%' }
        }}
      />
    </Grid>
  );
}

export default RunFilters;
